import { Box, Paper, Stack, Tab, Tabs, Typography } from "@mui/material";
import { CLIMATE_LAYERS } from "../../../../../../enums/layers";
import { useEffect } from "react";
import Timeseries from "../../../../../../Components/TimeseriesChart/partials/TimeseriesItem/partials/Timeseries";
import useQueryState from "../../../../../../hooks/useQueryState";

const ClimatesChart = () => {
  const {
    queryState: {
      climate,
      ui: { mapSidebar },
    },
    setQueryState,
  } = useQueryState();

  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setQueryState({ climate: newValue });
  };

  useEffect(() => {
    window.dispatchEvent(new Event("resize"));
  }, [mapSidebar]);

  return (
    <Stack component={Paper} flex={2} minWidth={0} minHeight={0}>
      <Tabs
        value={climate}
        onChange={handleChangeTab}
        sx={{
          minHeight: 42,
          height: 42,
          "& .MuiTab-root": {
            minHeight: 42,
            height: 42,
            padding: "0 12px",
          },
          width: "100%",
          "& .MuiTab-root.Mui-selected": {
            color: "#2146A4",
          },
          "& .MuiTabs-indicator": {
            borderBottom: "2px solid #2146A4",
          },
        }}
      >
        {CLIMATE_LAYERS.map(({ displayName }) => (
          <Tab
            key={displayName + " tab"}
            value={displayName}
            label={
              <Typography
                lineHeight="24px"
                letterSpacing="0.4px"
                variant="subtitle2"
                fontWeight={600}
              >
                {displayName}
              </Typography>
            }
          />
        ))}
      </Tabs>
      <Stack flex={1} minHeight={0} minWidth={0} overflow="hidden">
        <Box
          flex={1}
          minHeight={0}
          minWidth={0}
          overflow="hidden"
          width="100%" // 👈 ADD THIS
          maxWidth="100%"
        >
          <Timeseries type="climate" />
        </Box>
      </Stack>
    </Stack>
  );
};

export default ClimatesChart;
